module.exports = __webpack_public_path__ + "img/partying-face.4858c222.svg";